<template>
  <section>
    <TheArticleList
      :articles="temples.data"
      linkPath="temple"
      displayType="card"
    >
      <template>
        <TheListTitle :listTitle="articleTitle" prefix="temple" />
        <ArticleFilter>
          <TheSelect
            @onChange="(value) => handleChange('locale', value)"
            @onReset="handleReset('locale')"
            :options="localeOptions"
            placeholder="行政區"
          />
          <TheSelect
            @onChange="(value) => handleChange('topic', value)"
            @onReset="handleReset('topic')"
            :options="topicOptions"
            placeholder="主題"
          />
        </ArticleFilter>
      </template>
    </TheArticleList>
    <TheListPagination
      category="temples"
      :pages="temples"
      @update:getUpdatedArticles="$store.dispatch('getUpdatedArticles', $event)"
    />
  </section>
</template>

<script>
// import { lazyloading } from '@/utils/lazyloading';
import { getArticleString } from '@/config/articleString';

import TheListTitle from '@/components/list/TheListTitle';
import ArticleFilter from '@/components/list/ArticleFilter';
import TheArticleList from '@/components/list/TheArticleList';
import TheListPagination from '@/components/list/TheListPagination';
import TheSelect from '@/components/TheSelect';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'TheTemples',
  metaInfo() {
    return {
      title: '參觀總覽',
      meta: [
        {
          vmid: 'og:url',
          property: 'og:url',
          content: this.productionWholeReference,
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: '臺南宗教藝術-參觀總覽',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: '收錄本站目前介紹的臺南廟宇與祂們各自精彩的廟宇藝術。',
        },
      ],
    };
  },
  data() {
    return {
      locale: null,
      topic: null,
    };
  },
  computed: {
    ...mapGetters(['temples', 'templeFilter', 'productionHostname']),
    articleTitle() {
      return getArticleString('temple', 'headline');
    },
    productionWholeReference() {
      return `${this.productionHostname}${window.location.pathname}${window.location.search}`;
    },
    localeOptions() {
      return this.toOptions('NS_LOCALE');
    },
    topicOptions() {
      return this.toOptions('NS_TOPIC');
    },
  },
  async mounted() {
    Promise.all([this.getTemples(), this.getTempleFilter()]);
    // await lazyloading();
  },
  methods: {
    ...mapMutations(['setArticleParams']),
    async getTemples() {
      // 載入藝品列表頁，以 API 資料作為初始值
      const params = {};
      this.locale && (params.locale = this.locale.value);
      this.topic && (params.topic = this.topic.value);
      this.setArticleParams(params);

      try {
        await this.$store.dispatch('getTemples', params);
      } catch (e) {
        console.log(e);
      }
    },
    async getTempleFilter() {
      // 載入篩選的資料
      try {
        await this.$store.dispatch('getTempleFilter');
      } catch (e) {
        console.log(e);
      }
    },
    handleChange(field, value) {
      this[field] = value;
      this.getTemples();
    },
    handleReset(field) {
      this[field] = null;
      this.getTemples();
    },
    toOptions(filed) {
      if (this.templeFilter[filed]) {
        return this.templeFilter[filed].map(({ name, id }) => ({
          label: name,
          value: id,
        }));
      } else {
        return [];
      }
    },
  },
  components: {
    TheListTitle,
    ArticleFilter,
    TheArticleList,
    TheListPagination,
    TheSelect,
  },
};
</script>

<style lang="scss" scoped></style>
